import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 52px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};
  background-color: ${({ theme }) => theme.colors.surface.surface};
  margin-top: 8px;

  .colIcon {
    width: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;

    .disciplineIcon {
      color: ${({ theme }) => theme.colors.surface.onSurfaceVariant} !important;
    }
  }

  .colAcronym {
    width: 90px;
    flex-shrink: 0;
  }

  .colName {
    width: 30%;
    flex-shrink: 0;
  }

  .colStages {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
    overflow: hidden;
  }

  .colActions {
    width: 90px;
    flex-shrink: 0;
    padding-right: 12px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;

    .actionBtn {
      height: 32px !important;
      width: 32px !important;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 !important;
      padding: 0 !important;

      .actionIcon {
        color: ${({ theme }) => theme.colors.secondary.onSecondary} !important;
      }

      &+.actionBtn {
        margin-left: 6px !important;
      }
    }
  }

  .rowText {
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.surface.onSurface};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .emptyStagesText {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
  }
`;

export const StagesChain = styled.div`
  display: flex;
  align-items: center;

  .stageBadge {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    height: 20px;
  }

  .stageBadge:not(:first-child) {
    margin-left: -3.5px;
  }

  .stageBadgeNotch {
    flex-shrink: 0;
    width: 10.5878px;
    height: 20px;
    background-color: ${({ theme }) => theme.colors.secondary.secondary};
    clip-path: path('M0.294898 1.70711C-0.335067 1.07714 0.111101 0 1.00201 0H10.5878V20H1.00201C0.111101 20 -0.335066 18.9229 0.294899 18.2929L6.46647 12.1213C7.63805 10.9497 7.63804 9.05025 6.46647 7.87868L0.294898 1.70711Z');
  }

  .stageBadgeTag {
    display: flex;
    align-items: center;
    height: 20px;
    padding: 0 8px;
    white-space: nowrap;
    font-size: 12px;
    font-weight: 600;
    line-height: normal;
    color: ${({ theme }) => theme.colors.secondary.onSecondary};
    background-color: ${({ theme }) => theme.colors.secondary.secondary};
  }

  .stageBadge.isFirst .stageBadgeTag {
    border-radius: 4px 0 0 4px;
  }

  .stageBadge.isLast .stageBadgeTag {
    border-radius: 0 4px 4px 0;
  }

  .stageBadge.isFirst.isLast .stageBadgeTag {
    border-radius: 4px;
  }

  .stageBadgePoint {
    flex-shrink: 0;
    width: 11.1716px;
    height: 20px;
    background-color: ${({ theme }) => theme.colors.secondary.secondary};
    clip-path: path('M0.343146 0C1.40401 0 2.42143 0.421427 3.17157 1.17157L10.5858 8.58579C11.3668 9.36684 11.3668 10.6332 10.5858 11.4142L3.17157 18.8284C2.42143 19.5786 1.40401 20 0.343146 20H0V0H0.343146Z');
  }
`;
